export const environment: any = {
    production: true,
    apiUrl: 'https://journey-wapi-dev.azurewebsites.net/api/v1',
    authApiUrl: {
      default: 'https://journey-wapi-dev.azurewebsites.net/api/v1'
    },
    clientId: '65dffd85-67cc-4a98-930c-28869b6f86e0',
    logoSrc: 'https://journeyblobdev.blob.core.windows.net/logo/logo.png',
    heroImageSrc: 'https://journeyblobdev.blob.core.windows.net/images/hero-illustration.png',
    title: 'Journey Platform (Dev)',
    tabTitle: 'Journey (Dev)',
    defaultLanguage: 'nl',
    homeRedirectPath: '/home',
    defaultRedirectPath: '/'
  };
  